export enum USState {
    AL = "Alabama",
    AK = "Alaska",
    // AS = "American Samoa",
    AZ = "Arizona",
    AR = "Arkansas",
    CA = "California",
    CO = "Colorado",
    CT = "Connecticut",
    DE = "Delaware",
    DC = "District of Columbia",
    // FM = "Federated States Of Micronesia",
    FL = "Florida",
    GA = "Georgia",
    // GU = "Guam",
    HI = "Hawaii",
    ID = "Idaho",
    IL = "Illinois",
    IN = "Indiana",
    IA = "Iowa",
    KS = "Kansas",
    KY = "Kentucky",
    LA = "Louisiana",
    ME = "Maine",
    // MH = "Marshall Islands",
    MD = "Maryland",
    MA = "Massachusetts",
    MI = "Michigan",
    MN = "Minnesota",
    MS = "Mississippi",
    MO = "Missouri",
    MT = "Montana",
    NE = "Nebraska",
    NV = "Nevada",
    NH = "New Hampshire",
    NJ = "New Jersey",
    NM = "New Mexico",
    NY = "New York",
    NC = "North Carolina",
    ND = "North Dakota",
    // MP = "Northern Mariana Islands",
    OH = "Ohio",
    OK = "Oklahoma",
    OR = "Oregon",
    // PW = "Palau",
    PA = "Pennsylvania",
    // PR = "Puerto Rico",
    RI = "Rhode Island",
    SC = "South Carolina",
    SD = "South Dakota",
    TN = "Tennessee",
    TX = "Texas",
    UT = "Utah",
    VT = "Vermont",
    // VI = "Virgin Islands",
    VA = "Virginia",
    WA = "Washington",
    WV = "West Virginia",
    WI = "Wisconsin",
    WY = "Wyoming",
};

  
export enum SecurityType {
    AirportSeaportRevenues = "Airport/Seaport Revenues",
    CharterSchool = "Charter School",
    DoubleBarrelRevenue = "Double Barrel Revenue",
    ElectricRevenues = "Electric Revenues",
    HospitalRevenues = "Hospital Revenues",
    HousingRevenues = "Housing Revenues",
    HotelRevenues = "Hotel Revenues",
    LeaseRent = "Lease/Rent",
    LimitedTaxGeneralObligation = "Limited Tax General Obligation",
    LoanAgreement = "Loan Agreement",
    MunicipalUtilityDistrict = "Municipal Utility District",
    OtherRevenue = "Other Revenue",
    PrivateHigherEducation = "Private Higher Education",
    PublicHigherEducation = "Public Higher Education",
    SalesExciseTax = "Sales/Excise Tax",
    SeniorLiving = "Senior Living",
    SpecialAssessments = "Special Assessments",
    SpecialTax = "Special Tax",
    TaxIncrementRevenues = "Tax Increment Revenues",
    TobaccoSettlement = "Tobacco Settlement",
    TransportationRevenues = "Transportation Revenues",
    UnlimitedTaxGeneralObligation = "Unlimited Tax General Obligation",
    UtilityRevenue = "Utility Revenue"
}
  
export enum RatingAssumption {
    AAA = "AAA",
    AAPlus = "AA+",
    AA = "AA",
    AAMinus = "AA-",
    APlus = "A+",
    A = "A",
    AMinus = "A-",
    BBBPlus = "BBB+",
    BBB = "BBB",
    BBBMinus = "BBB-",
}

export enum ExpandedRatingOptions {
    AAA = "AAA",
    AAPlus = "AA+",
    AA = "AA",
    AAMinus = "AA-",
    APlus = "A+",
    A = "A",
    AMinus = "A-",
    BBBPlus = "BBB+",
    BBB = "BBB",
    BBBMinus = "BBB-",
    BBPlus = "BB+",
    BB = "BB",
    BBMinus = "BB-",
}

export enum TaxDesignation {
    BankQualified = "Bank Qualified",
    NonBankQualified = "Non-Bank Qualified",
    SubjectToAMT = "Subject to AMT",
    Taxable = "Taxable",
}

export enum PrincipalRate {
    Annual = "Annual",
    SemiAnnual = "Semi-Annual",
}

export enum CouponSelection {
    FiCurveCouponPrediction = "Spline Coupon Prediction",
    FivePercentCoupon = "5% Coupon",
}

export enum SaleMethod {
    Negotiated = "Negotiated",
    Competitive = "Competitive",
}

export function getStateName(key: keyof typeof USState): string {
    if (key in USState) return USState[key];
    return key;
}
